import { useTranslation } from 'react-i18next';
import { WalletContainer } from '@/features/wallet/containers/wallet-container';

export default function WalletPage() {
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold tracking-tight">{t('wallet.title')}</h1>
      <WalletContainer />
    </div>
  );
}
